import IconButton from '@mui/material/IconButton'
import SearchIcon from '@mui/icons-material/Search'
import InputBase from '@mui/material/InputBase'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import classes from './requestSearch.module.scss'
import { Checkbox } from '@/ui'
import { useSelector } from 'react-redux'
import { userSelectors } from '@/entity'

const RequestSearch = ({ filter, setFilter, fetchData }) => {
	const { t } = useTranslation()
	const activeRole = useSelector(userSelectors.activeRole)
	const isEmployer = useMemo(() => activeRole === 'ROLE_EMPLOYER', [activeRole])

	const updateFilter = (e, name) => {
		setFilter({ ...filter, [name]: e?.target?.value || (typeof e === 'string' && e) || '' })
	}

	return (
		<div className={classes.searchRow}>
			<div className={classes.searchField}>
				<div className={classes.searchField__left}>
					<IconButton type="submit" aria-label="search">
						<SearchIcon />
					</IconButton>
					<InputBase
						fullWidth
						placeholder={t('pension.searchInput')}
						inputProps={{
							'aria-label': 'search',
						}}
						value={filter.src}
						onChange={(e) => updateFilter(e, 'src')}
						onKeyDown={(e) => {
							if (e.key === 'Enter') {
								e.preventDefault()
								fetchData()
							}
						}}
					/>
				</div>
				<span className={classes.searchField__button} onClick={() => fetchData()}>
					{t('find')}
				</span>
			</div>
			{/* Checkbox для representative_requests */}
			{!isEmployer ? (
				<div className={'ml-38'}>
					<Checkbox
						name="representative_requests"
						label={t('representative_requests')}
						value={filter.representative || false}
						onChange={(value) => {
							// Устанавливаем значение `representative` как true или false
							const updatedFilter = { ...filter, representative: !!value }
							setFilter(updatedFilter)

							// Выполняем поиск
							fetchData(updatedFilter)
						}}
					/>
				</div>
			) : null}
		</div>
	)
}

export default RequestSearch
